import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'ngx-search',
  templateUrl: './ngx-search.component.html',
  styleUrls: ['./ngx-search.component.scss']
})
export class NgxSearchComponent implements OnInit {

  // place holder
  @Input() placeholder: string = 'Search';
  // initial value
  @Input() value: string = null;
  // on search
  @Output() onSearch = new EventEmitter<string>();
  
  ngOnInit(): void { }

  handleSearch(value: string) {
    this.onSearch.emit(value);
  }

}
